import { Component, Input, OnInit } from '@angular/core';
import { DocumentService } from '../document.service';
import { Document } from '../document';
import { NotificationService } from '../../shared/notification.service';
import { SelectComparisons } from '../../shared/pipes/select.comparisons';

@Component({
  selector: 'app-document-select',
  templateUrl: 'select.component.html',
})
export class DocumentSelectComponent extends SelectComparisons
  implements OnInit {
  /**
   * The model that we will be adding the document to.
   */
  @Input() model: any;

  /**
   * Do we require this field in the main form it is
   * included in?
   */
  @Input() required: boolean;

  /**
   * A list of all the documents currently loaded.
   *
   * @type {Document[]}
   */
  public documents: Document[] = [];

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = true;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {DocumentService} documentService
   * @param {NotificationService} notificationService
   */
  constructor(
    private documentService: DocumentService,
    private notificationService: NotificationService,
  ) {
    super();
    this.documentService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  /**
   * When the component is initialised we set it to load
   * page one of the document list.
   */
  public ngOnInit(): void {
    this.loadDocuments(1, 10000);
  }

  /**
   * Loads a list of documents using the given per page limit.
   *
   * @param {number} page The current page we require.
   * @param {number} limit The number of results per page.
   */
  public loadDocuments(page?: number, limit?: number): void {
    const listDocuments = this.documentService
      .listDocuments(page, limit)
      .subscribe((documents: Document[]) => {
        this.documents = documents;
        listDocuments.unsubscribe();
      });
  }
}
